const map = {
    state: {
        context: null // active marker
    },
    mutations: {
        SET_CONTEXT(state, context) {
            state.context = context
        }
    },
    actions: {
        showMapContext({commit}, survey) {
            commit('SET_CONTEXT', survey)
        }
    },
    getters: {
        // empty
    }
}

export default map
